<template>
  <div class="footer-area-wrapper" :class="FooterStyle">
    <div class="footer-area section-space--ptb_90">
      <div class="container">
        <div class="row footer-widget-wrapper justify-content-center">
          <div class="col-lg-4 col-md-6 footer-widget">
            <div class="footer-widget__logo mb-30">
              <a href="/#home">
                <img
                  src="../assets/img/logo/logo-dark.png"
                  class="img-fluid logo-dark"
                  alt="logo"
                />
                <img
                  src="../assets/img/logo/logo-light.png"
                  class="img-fluid logo-light"
                  alt="logo"
                />
              </a>
            </div>
            <ul class="footer-widget__list">
              <li>
                Pixel is bringing gamification to NFTs and Defi. Contact us if you'd like to be
                <i>pixel-powered!</i>
              </li>
              <li>
                <a href="mailto:powerup@pxl.limited" class="hover-style-link"
                  >powerup@pxl.limited</a
                >
              </li>
            </ul>
          </div>
          <div class="col-lg-2 col-md-3 footer-widget">
            <h6 class="footer-widget__title mb-20">Quick links</h6>
            <ul class="footer-widget__list">
              <li>
                <a href="/#home" class="hover-style-link scroll">Home</a>
              </li>
              <li>
                <a href="https://www.pixelpotus.com" target="_blank" class="hover-style-link"
                  >Play PixelPotus</a
                >
              </li>
              <li>
                <a href="https://www.pixeldebates.com" target="_blank" class="hover-style-link"
                  >Play PixelDebates</a
                >
              </li>
              <li>
                <a
                  href="https://quipuswap.com/swap/tez-KT1F1mn2jbqQCJcsNgYKVAQjvenecNMY2oPK_0"
                  target="_blank"
                  class="hover-style-link"
                  >Trade $PXL</a
                >
              </li>
              <li>
                <a
                  href="https://app.crunchy.network/#/farms?q=pxl"
                  target="_blank"
                  class="hover-style-link"
                  >Farm pxlDAO</a
                >
              </li>
              <li>
                <a href="https://www.pixelpower.xyz" target="_blank" class="hover-style-link"
                  >Gather Power</a
                >
              </li>
              <li>
                <a href="https://www.tezerfly.xyz" target="_blank" class="hover-style-link"
                  >Try Tezerfly</a
                >
              </li>
            </ul>
          </div>
          <div class="col-lg-2 col-md-3 footer-widget">
            <h6 class="footer-widget__title mb-20">Legal</h6>
            <ul class="footer-widget__list">
              <li>
                <router-link to="/terms" class="hover-style-link">Terms & Conditions</router-link>
              </li>
              <li>
                <router-link to="/privacy" class="hover-style-link">Privacy Policy</router-link>
              </li>
              <li>
                <router-link to="/disclaimer" class="hover-style-link">Disclaimer</router-link>
              </li>
              <li>
                <a href="mailto:support@pxl.limited" class="hover-style-link">Contact Support</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-copyright-area border-top section-space--ptb_30">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6 text-center text-md-left">
            <span class="copyright-text"> &copy; 2021 <b>Pixel Global, Ltd.</b> </span>
          </div>
          <div class="col-md-6 text-center text-md-right">
            <ul class="list ht-social-networks solid-rounded-icon">
              <!-- <li class="item">
                                <a href="https://www.facebook.com/" target="_blank" class="social-link"> <i class="fab fa-facebook social-link-icon"></i> </a>
                            </li> -->
              <li class="item">
                <a href="https://twitter.com/pixelpotus" target="_blank" class="social-link">
                  <i class="fab fa-twitter social-link-icon"></i>
                </a>
              </li>
              <!-- <li class="item">
                                <a href="https://www.instagram.com/" target="_blank" class="social-link"> <i class="fab fa-instagram social-link-icon"></i> </a>
                            </li> -->
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterMain',
  props: ['FooterStyle'],
}
</script>
